<template>
	<layout>
		<div slot="masthead">
			<masthead :bgImage="bgImage" class="masthead">
				<template slot="headline">Page not Found (404)</template>
			</masthead>
		</div>
		<div :class="['content', {extra: $mq.desktop}]" slot="body">
			<container :collapse="$mq.desktop">
				<p>We're sorry, but we can't seem to find the page you're looking for.</p>
				<p>You will be redirected to our homepage shortly...</p>
			</container>
		</div>
		<template slot="footer">
			<FooterCTA />
		</template>
	</layout>
</template>

<script>

	import Layout from '@/layouts/layoutB'
	import Masthead from '@/layouts/layoutB/masthead'
	import FooterCTA from '@/components/FooterCTA'

	export default {
		routeConfig: {
			name: 'page-not-found', path: '*'
		},
		metaInfo () {
			return {
				title: `404: Page not Found`,
				meta: [
					{ name: 'prerender-status-code', content: '404' }
				]
			}
		},
		components: { Layout, Masthead, FooterCTA },
		data () {
			return {
				bgImage: require('img/bugeyes.jpg'),
				homepageTimeout: null
			}
		},
		created () {
			this.homepageTimeout = setTimeout(() => {
				this.$router.push({ name: 'homepage' })
			}, 6000)
		},
		beforeDestroy () {
			if(this.homepageTimeout) {
				clearTimeout(this.homepageTimeout)
			}
		}
	}

</script>

<style lang="scss" scoped>

	.content {
		width:100%; color:#6D6E71; padding:5vw 0;
		&.extra {
			padding:8.7rem 11.2rem 0;
		}
	}

</style>



// WEBPACK FOOTER //
// src/routes/404.vue